import { render, staticRenderFns } from "./closure-production.vue?vue&type=template&id=49a2516a"
import script from "./closure-production.vue?vue&type=script&lang=js"
export * from "./closure-production.vue?vue&type=script&lang=js"
import style0 from "./closure-production.vue?vue&type=style&index=0&id=49a2516a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports